/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Ota_Runtime_VersionInputs */

const en_mobile_ota_runtime_version = /** @type {(inputs: Mobile_Ota_Runtime_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runtime version`)
};

const es_mobile_ota_runtime_version = /** @type {(inputs: Mobile_Ota_Runtime_VersionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versión de runtime`)
};

/**
* | output |
* | --- |
* | "Runtime version" |
*
* @param {Mobile_Ota_Runtime_VersionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_ota_runtime_version = /** @type {((inputs?: Mobile_Ota_Runtime_VersionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Ota_Runtime_VersionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_ota_runtime_version(inputs)
	return en_mobile_ota_runtime_version(inputs)
});